<template>
  <div ref="viewer" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0" data-bind="dxReportViewer: $data"></div>
</template>
<script>
import 'devexpress-reporting/dx-webdocumentviewer';
import {
  DxReportViewer
} from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils'
export default {
  name: "WebDocumentViewer",
  mounted() {
    const reportUrl = ko.observable(this.$route.query.reportName);
    const viewerModel = ko.observable(null)
    const requestOptions = {
      host: this.$route.query.reportHost,
      invokeAction: "DXXRDV",
      zoom: 1
    }
    ajaxSetup.ajaxSettings = {
      // xhrFields: {
      //   withCredentials: true
      // },
      headers: {
        // 'X-XSRF-TOKEN': this.$route.query.csrf,
        Authorization: this.$route.query.acc,
        Accept: 'application/json',
        contentType: 'application/json',
        NBOData: this.$route.query.reportApi
      }
    }
    viewerModel.subscribe(function(newModel) {
      if (newModel)
        newModel.reportPreview.zoom(100);
    })
    const viewer = new DxReportViewer(this.$refs.viewer, {
      reportUrl,
      requestOptions
    });
    viewer.render();
  },
  beforeUnmount() {
    ko.cleanNode(this.$refs.viewer);
  }
};
</script>
